import { Turnstile } from '@marsidev/react-turnstile';
import { useSiteSettings } from '@/context/SiteSettingsContext';

export default function TurnstileWidget({ onVerify, onError, onExpire }) {
  const { settings } = useSiteSettings();
  
  // Only render if site key is configured
  if (!settings?.turnstile_site_key) {
    return null;
  }

  return (
    <div className="turnstile-container" data-testid="turnstile-widget">
      <Turnstile
        siteKey={settings.turnstile_site_key}
        onSuccess={onVerify}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme: 'light',
          size: 'normal'
        }}
      />
    </div>
  );
}
